// {
//   "DefaultLeadTime": "Hardware 8 - 12 weeks, Software 4 - 6 weeks",
//   "apiBaseUrl": "https://localhost:44310/api",
//   "apiBaseUrl1": "http://quotesapi.inovaxe.com/api"


// }

const config = {
    apiBaseUrl: "",
    DefaultLeadTime: "",
    currencySymbol: "$",
    currencyPosition: "before",
    isTest: false
};

let loadPromise = null;

const coerceTestFlag = (value) => {
    if (value === true || value === 1) return true;
    if (typeof value === "string") {
        const normalized = value.trim().toLowerCase();
        return normalized === "true" || normalized === "1";
    }
    return false;
};

export const applyTestTheme = (isTest) => {
    if (typeof document === "undefined") return;
    document.documentElement.classList.toggle("is-test", !!isTest);
};

const applyConfig = (runtimeConfig = {}) => {
    config.apiBaseUrl = runtimeConfig.apiBaseUrl || "";
    config.DefaultLeadTime = runtimeConfig.DefaultLeadTime || "";
    config.currencySymbol = runtimeConfig.currencySymbol || "$";
    config.currencyPosition = runtimeConfig.currencyPosition || "before";
    config.isTest = coerceTestFlag(runtimeConfig.IsTest ?? runtimeConfig.isTest);
    applyTestTheme(config.isTest);
    return config;
};

export const normalizeCurrencySymbol = (symbol) => {
    if (!symbol) return "$";
    return String(symbol).trim() || "$";
};

export const formatCurrency = (value, options = {}) => {
    const numericValue = Number(value ?? 0);
    if (!Number.isFinite(numericValue)) return "0.00";

    const symbol = normalizeCurrencySymbol(options.symbol ?? config.currencySymbol ?? "$");
    const position = options.position ?? config.currencyPosition ?? "before";
    const absValue = Math.abs(numericValue);
    const formattedValue = absValue.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    const sign = numericValue < 0 ? "-" : "";

    if (position === "after") {
        return `${sign}${formattedValue}${symbol}`;
    }

    return `${sign}${symbol}${formattedValue}`;
};

export const loadConfig = async () => {
    if (config.apiBaseUrl) return config;
    if (loadPromise) return loadPromise;

    loadPromise = (async () => {
        try {
            const cached = sessionStorage.getItem("appConfig");
            if (cached) {
                const parsed = JSON.parse(cached);
                if (parsed && (parsed.IsTest !== undefined || parsed.isTest !== undefined)) {
                    return applyConfig(parsed);
                }
            }
        } catch {
            sessionStorage.removeItem("appConfig");
        }

        const configUrls = [
            `${process.env.PUBLIC_URL}/Config.json`,
            `${process.env.PUBLIC_URL}/config.json`
        ];

        let lastError = null;

        for (const url of configUrls) {
            try {
                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`Failed to load ${url}. Status: ${response.status}`);
                }

                const runtimeConfig = await response.json();
                applyConfig(runtimeConfig);

                try {
                    sessionStorage.setItem("appConfig", JSON.stringify(runtimeConfig));
                } catch {
                    // ignore quota errors
                }

                return config;
            } catch (error) {
                lastError = error;
            }
        }

        loadPromise = null;
        console.error("Failed to load public config files:", lastError);
        throw lastError;
    })();

    return loadPromise;
};

// export default config; files:", lastError);
//     throw lastError;
// };

export default config;